import { gql } from "@apollo/client";

const GET_FILE = gql`
  query getFile($id: String!, $clientIdentifier: String) {
    file(id: $id, clientIdentifier: $clientIdentifier) {
      id
      clientIdentifier
      content
      contentType
      createdAt

      fileName
      fileType
      source
    }
  }
`;

export default GET_FILE;
